<template>
  <div>
    <!-- <div class="py-2">
      <h3 class="section-title">Contact Person</h3>
      <p class="section-subtitle">Who should we reach out to for onboarding?</p>
    </div> -->

    <div class="details-stack">

      <div class="mb-2">
        <AppTextField :model-value="first_name" label="First Name" label-icon="mdi-account-outline" placeholder="John"
          :error-messages="errors.first_name ? [errors.first_name] : []"
          @update:modelValue="$emit('update:first_name', $event)" />
      </div>

      <div class="mb-2">
        <AppTextField :model-value="last_name" label="Last Name" label-icon="mdi-account-outline" placeholder="Doe"
          :error-messages="errors.last_name ? [errors.last_name] : []"
          @update:modelValue="$emit('update:last_name', $event)" />
      </div>

      <div class="mb-2">
        <AppTextField :model-value="email" label="Email" label-icon="mdi-email-outline" type="email"
          placeholder="name@example.com" :error-messages="errors.email ? [errors.email] : []"
          @update:modelValue="$emit('update:email', $event)" />
      </div>

       <div class="mb-2">
         <AppTextField :model-value="phone" label="Phone" label-icon="mdi-phone-outline" type="tel"
           v-mask="'(###) ### ####'" placeholder="(555) 123 4567" :error-messages="errors.phone ? [errors.phone] : []"
           @update:modelValue="$emit('update:phone', $event)" />
       </div>

       <div class="mb-2">
         <AppTextField :model-value="phone_alt" label="Alt. Phone" label-icon="mdi-phone-outline" type="tel"
           v-mask="'(###) ### ####'" placeholder="(555) 987 6543" hide-details
           @update:modelValue="$emit('update:phone_alt', $event)" />
       </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import AppTextField from "@/shared/components/ui/AppTextField.vue";

withDefaults(
  defineProps<{
    first_name: string;
    last_name: string;
    email: string;
    phone: string;
    phone_alt: string;
    errors: {
      first_name?: string;
      last_name?: string;
      email?: string;
      phone?: string;
      phone_alt?: string;
    };
  }>(),
  {
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    phone_alt: "",
    errors: () => ({}),
  },
);

defineEmits([
  "update:first_name",
  "update:last_name",
  "update:email",
  "update:phone",
  "update:phone_alt",
]);
</script>

<style scoped>
.section-title {
  text-transform: capitalize;
}

.section-subtitle {
  margin: 0 0 14px;
  color: #73829a;
  font-size: 14px;
}

.details-stack {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
</style>
